
module.directive('lastEdited', function($interval, moment) {
    return {
        restrict: 'E',
        scope: {when: '='},
        template: ['<span>',
            'Last edited <span fade-text="{{ time }}"></span>',
            ' by <span fade-text="{{ name }}"></span>',
        '</span>'].join(''),
        link: function(scope, element, attrs) {
            var duration, cancel;

            function getMilliseconds(unit) {
                return moment.duration(1, unit).asMilliseconds();
            }

            function getIntervalDuration() {
                if (!moment.isMoment(scope.when) || !scope.when.isValid()) {
                    return 0;
                }
                var dur = moment.duration(moment().diff(scope.when));
                if (dur.asSeconds() < 45) {
                    return getMilliseconds('second');
                }
                if (dur.asMinutes() <= 45) {
                    return getMilliseconds('minute');
                };
                if (dur.asHours() <= 22) {
                    return getMilliseconds('hour');
                }
                return getMilliseconds('day');
            }

            function tick() {
                var newDuration = getIntervalDuration()
                if (newDuration <= 0) {
                    $interval.cancel(cancel);
                    return;
                }
                if (newDuration > duration) {
                    duration = newDuration;
                    $interval.cancel(cancel);
                    cancel = $interval(tick, duration);
                }
                scope.time = scope.when.fromNow();
            }

            scope.$watch('when', function() {
                duration = 0;
                tick();
            });

            attrs.$observe('name', function(name) {
                scope.name = name;
            });
        },
    };
});